// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__f5rc0","selects":"Documents_selects__1y-Dg"};